import { Box, Text } from '@wix/design-system';
import { FunctionComponent } from 'react';
import { TimerSmall } from '@wix/wix-ui-icons-common';
import { COLORS } from '../../../../../utils/theme';
import css from './index.module.scss';
import { DATA_HOOKS } from '../../../../../dataHooks';
import { useTranslation } from '@wix/wix-i18n-config';

type ReadingTimeProps = {
  readingTimeInMinutes: number;
};

export const ReadingTime: FunctionComponent<ReadingTimeProps> = ({
  readingTimeInMinutes,
}) => {
  const { t } = useTranslation();

  return (
    <Box className={css.readingTimeInMinutes} verticalAlign="middle">
      <TimerSmall color={COLORS.D40} className={css.timerIcon} />
      <Text
        size="tiny"
        color={COLORS.D40}
        className={css.timeToRead}
        dataHook={DATA_HOOKS.SEARCH_RESULT_ITEM_TIME_TO_READ}
      >
        {t('informative-article-time-to-read', {
          time: readingTimeInMinutes,
        })}
      </Text>
    </Box>
  );
};
